import React from 'react';
import ModuleTable from 'Components/Core/ModuleTable';
import FormElement from 'Components/Core/Form/FormElement';
import BooleanIcon from 'Components/Core/BooleanIcon';
import './Foren.css';

export default function Foren(props) {

    const x = props.x;
    const wafId = props.id;
    const dialogFormId = "form-" + props.id;
    const editingForumId = React.useRef(null);

    const formFields =
        <React.Fragment>
            <FormElement type="text"
                x={x}
                dialogId={dialogFormId}
                wafId={wafId}
                id="name"
                mandatory={true}
                title="Forum"
                fieldValue=""
                maxLength="25"
            />
            <FormElement type="textarea"
                x={x}
                dialogId={dialogFormId}
                wafId={wafId}
                id="description"
                mandatory={false}
                title="Beschreibung"
                fieldValue=""
                maxLength="200000"
            />
            <FormElement type="number"
                x={x}
                dialogId={dialogFormId}
                wafId={wafId}
                id="maxlines"
                mandatory={false}
                title="Max. sichtbare Zeilen je Beitrag"
                fieldValue="10"
            />
            <FormElement type="checkbox" x={x} wafId={wafId} id="simpleheader" title="Vereinfachte Kopfzeile (nur Name & Thema)" />
            <FormElement type="checkbox" x={x} wafId={wafId} id="disabled" title="Inaktiv" />
        </React.Fragment>


    return (
        <ModuleTable
            id={props.id}
            tableId="id"
            dialogFormId={dialogFormId}
            x={x}
            classes={`module-foren`}
            tableClasses={`foren-list`}
            title={props.title}
            addDeleteRow={x.was.memberLevel < 3}
            addTitle="Neues Forum anlegen"
            module="Posting"
            listTask="ForenList"
            deleteTask="DeleteForum"
            onAddHeader={(addHeader) => {
                addHeader('Forum');
                addHeader('Beschreibung');
                addHeader('Max. Zeilen');
                addHeader('Einf. Kopf');
                addHeader('Deaktiviert');
            }}
            onAddColumn={(key, value) => {
                switch (key) {
                    case 'name':
                    case 'description':
                    case 'maxlines':
                        return value;
                    case 'simpleheader':
                    case 'disabled':
                        return <BooleanIcon value={value} />;
                    default:
                        return false;
                }
            }}
            onEditRow={(e, rowFields, rowId) => {
                editingForumId.current = rowId;
                x.waf.setAddSend(wafId, 'id', rowId);
                x.waf.set(wafId, 'name', rowFields.name);
                x.waf.set(wafId, 'description', rowFields.description);
                x.waf.set(wafId, 'maxlines', rowFields.maxlines);
                x.waf.set(wafId, 'simpleheader', rowFields.simpleheader);
                x.waf.set(wafId, 'disabled', rowFields.disabled);
                x.waf.hide(wafId, 'message');
                x.wad[dialogFormId].setTitle("Forum bearbeiten");
                x.wad[dialogFormId].show(() => { x.waf.focus(wafId, 'name') });
            }}
            formFields={formFields}
            formSendTask="SaveForum"
            sendButtonLevel={3}
            onAfterSend={() => {
                const id = editingForumId.current;
                const cached = id && x.was.foren[id];
                if (cached) {
                    const newMaxLines = parseInt(x.waf.get(wafId, 'maxlines'), 10);
                    const newSimpleHeader = (x.waf.get(wafId, 'simpleheader') === 1) ? 1 : 0;
                    if (newMaxLines !== cached.maxlines || newSimpleHeader !== parseInt(cached.simpleheader, 10)) {
                        x.wah.addHint('Die Änderung wird erst nach einem Neuladen der Seite aktiv.', false, 'Neu laden', () => window.location.reload());
                        x.was.sendSoftwareUpdate();
                    }
                }
                editingForumId.current = null;
            }}
        />
    )

};
